// removed by extract-text-webpack-plugin
module.exports = {"footer":"G_tSfgp_AclI7T0V7i4G0","icon":"_1N8XNxWmLsa9hvhyk3Ivyn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/footer.css
// module id = 30
// module chunks = 0